import { z } from "zod";

const AllResources = "*";

enum AccountEntryType {
  Credit = "Credit",
  Debit = "Debit",
}

const AddressSchema = z.object({
  address: z.string(),
  address_auxiliary: z.string().optional(),
  postal_code: z.string(),
  city: z.string(),
  state: z.string(),
  country: z.string(),
});

type AddressType = z.infer<typeof AddressSchema>;

const AuditableSchema = z.object({
  id: z.string().uuid().min(1),
  created_date: z.string(),
  update_date: z.string(),
  created_by: z.string(),
  updated_by: z.string(),
  version: z.number(),
});

type Auditable = z.infer<typeof AuditableSchema>;

enum AccountType {
  Asset = "Asset",
  Equity = "Equity",
  Liability = "Liability",
}

enum BusinessDayRule {
  STOCK_EXCHANGE = "Stock Exchange",
}

enum DayCountConvention {
  ACTUAL_360 = "Actual/360",
  ACTUAL_365 = "Actual/365",
}

enum ContractType {
  LOAN = "loans",
  EQUITY_SWAP = "equity_swaps",
  SPOT = "spot",
}

enum OptionType {
  CALL = "call",
  PUT = "put",
}

enum Side {
  PARTY_A = "PartyA",
  PARTY_B = "PartyB",
}

enum Status {
  ACTIVE = "ACTIVE",
  PENDING = "PENDING",
  TERMINATED = "TERMINATED",
  VOID = "VOID",
}

enum ForwardType {
  CALENDAR = "calendar",
  PERPETUAL = "perpetual",
}

enum SettlementPeriod {
  PERPETUAL = "perpetual",
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
}

enum TradeSide {
  BUY = "Buy",
  SELL = "Sell",
}

enum ValuationTimezone {
  "America/New York" = "America/New York",
}

const InstrumentSchema = z.object({
  enabled: z.boolean().optional().default(true),
  name: z.string(),
  venue_id: z.string().uuid(),
  native_id: z.string().uuid(),
  native_name: z.string(),
  is_active: z.boolean().optional(),
  underlying_id: z.string().uuid(),
  quote_currency_name: z.string(),
  settlement_currency_name: z.string(),
  settlement_period: z.nativeEnum(SettlementPeriod),
  creation_timestamp: z.string(),
  expiration_timestamp: z.string().optional(),
  min_trade_amount: z.string(),
  contract_size: z.string(),
  tick_size: z.string(),
});

export {
  AccountEntryType,
  AccountType,
  AddressSchema,
  AllResources,
  AuditableSchema,
  BusinessDayRule,
  ContractType,
  DayCountConvention,
  ForwardType,
  InstrumentSchema,
  OptionType,
  SettlementPeriod,
  Side,
  Status,
  TradeSide,
  ValuationTimezone
};
export type { AddressType, Auditable };

